<template>
  <!-- prettier-ignore -->
  <div
    v-if="!isDisabled"
    class="dvp"
  >
    <basket-widget
      class="dvp-basket"
      :options="basketOptions"
    />

    <session-menu />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import basketStore from '@/store/basket'

import BasketWidget from '@/components/BasketWidget/BasketContainer'
import SessionMenu from '@/components/Session/Menu.vue'

import { ROUTE_NAME } from '@/config/constants'

// HOOKS
const route = useRoute()

// INIT
const props = defineProps({
  language: {
    type: String,
    required: true,
  },
  options: {
    type: Object,
    required: true,
  },
})

// COMPUTED
const basketOptions = computed(() => {
  return props.options?.basket || {}
})

const isDisabled = computed(() => {
  return basketStore.basket.submitted || route.meta?.headerDisabled || route.name === ROUTE_NAME.ONBOARDING
})
</script>

<style name="mobile" scoped>
.dvp {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  :deep(.button.parent) {
    height: 34px;
    padding: 0 10px;
    margin: 0;
    min-height: auto;
    border-radius: 0;
    font-size: 16px;
  }

  :deep(.basket-toggle) {
    height: 34px;
    padding: 0 10px;
    margin: 0;
    min-height: auto;
    border-radius: 0;
    font-size: 16px;
    padding-top: 9px;
  }
}
</style>
